// src/pages/ledger/TaxInvoicePage.jsx
import React from "react";

const TaxInvoicePage = () => {
  return (
    <div className="min-h-screen bg-black text-white p-6">
      <h1 className="text-2xl font-bold text-blue-400 mb-4">
        Tax Invoice
      </h1>
      <p className="text-white text-sm">
        Here you can create and print tax invoices for your MSME business.
      </p>
      {/* Add your actual form or features here */}
    </div>
  );
};

export default TaxInvoicePage;
